const formatTranslationKeys = (key) => {
	return key.replace(/ |\.|\+|\&|\[|\]/g, '_')
}

const syncTimeout = async (delay) => {
    await new Promise(resolve => {
        setTimeout(resolve, delay)
    })
}

export default {
    methods: {
        formatTranslationKeys,
        syncTimeout
    }
}